export type AnalysisQuadTarget =
	| 'quad1'
	| 'quad2'
	| 'quad3'
	| 'quad4'
	| 'quadTotal';

export type AnalysisQuadOption = {
	text: string;
	label: string;
	value: AnalysisQuadTarget;
};

export const AnalysisQuadOptions = (): {
	[key in AnalysisQuadTarget]: AnalysisQuadOption;
} => ({
	quadTotal: {
		label: 'quad-quartile.quad.table.filters.quadTarget.quadTotal',
		text: 'quad-quartile.quad.table.filters.quadTarget.quadTotal',
		value: 'quadTotal',
	},
	quad1: {
		label: 'quad-quartile.quad.table.filters.quadTarget.quad1',
		text: 'quad-quartile.quad.table.filters.quadTarget.quad1',
		value: 'quad1',
	},
	quad2: {
		label: 'quad-quartile.quad.table.filters.quadTarget.quad2',
		text: 'quad-quartile.quad.table.filters.quadTarget.quad2',
		value: 'quad2',
	},
	quad3: {
		label: 'quad-quartile.quad.table.filters.quadTarget.quad3',
		text: 'quad-quartile.quad.table.filters.quadTarget.quad3',
		value: 'quad3',
	},
	quad4: {
		label: 'quad-quartile.quad.table.filters.quadTarget.quad4',
		text: 'quad-quartile.quad.table.filters.quadTarget.quad4',
		value: 'quad4',
	},
});

export const AnalysisQuadOptionValueMap: {
	[key in AnalysisQuadTarget]: number | null;
} = {
	quadTotal: null,
	quad1: 1,
	quad2: 2,
	quad3: 3,
	quad4: 4,
};
